export const F_CUSTOM_DOMAIN = 'CUSTOM_DOMAINS'
export const F_PWD_PROTECTION = 'PASSWORD_PROTECTION'
export const F_EDIT_MODE = 'EDIT_MODE'
export const F_API_KEY = 'API_KEY'
export const F_EMAIL_GATE = 'EMAIL_GATE'
export const F_FEEDBACK_MODE = 'FEEDBACK_MODE'
export const F_PRESENTATION_MODE = 'PRESENTATION_MODE'
export const F_MINIMALIST_MODE = 'F_MINIMALIST_MODE'
export const F_TRACKED_LINKS = 'F_TRACKED_LINKS'
export const F_DOWNLOAD_ANALYTICS = 'F_DOWNLOAD_ANALYTICS'
export const F_PDF_PAGE_ANALYTICS = 'PDF_PAGE_ANALYTICS'
export const F_PDF_TO_WEBSITE = 'PDF_TO_WEBSITE'
export const F_EMAIL_WHITELIST = 'EMAIL_WHITELIST'
